export default ({ store, redirect, app, route }) => {
  // If the user is not authenticated
  if (!store.getters['auth/isLogged']) {
    if (route.path) {
      store.commit('auth/setPathFrom', route.path);
    }
    store.commit('layout/setLoader', false);
    return redirect(app.localePath({ name: 'login' }));
  }
};
